import axiosClient from '@utils/axiosClient';

const fetch = axiosClient();

export const login = (payload) =>
  fetch({
    method: 'POST',
    url: '/login',
    body: payload,
  });

export const register = (payload) =>
  fetch({
    method: 'POST',
    url: '/register',
    body: payload,
  });

export const linkAccount = (payload) =>
  fetch({
    method: 'POST',
    url: '/link',
    body: payload,
  });

export const forgotPassword = (payload) =>
  fetch({
    method: 'POST',
    url: '/forgot_pin',
    body: payload,
  });

export const otpRequest = (payload) =>
  fetch({
    method: 'POST',
    url: '/otp_request',
    body: payload,
  });

export const otpConfirm = (payload) =>
  fetch({
    method: 'POST',
    url: '/otp_confirmation',
    body: payload,
  });

export const changePin = (payload) =>
  fetch({
    method: 'POST',
    url: '/change-pin',
    body: payload,
  });

export const verifyPin = (payload) =>
  fetch({
    method: 'POST',
    url: '/verify-pin',
    body: payload,
  });

export const getAccount = () =>
  fetch({
    method: 'GET',
    url: '/account-page',
  });

export const getReferralInfo = () =>
  fetch({
    method: 'GET',
    url: '/referral-info',
  });

export const checkGrabModalFeature = () =>
  fetch({
    method: 'GET',
    url: '/feature-settings',
    withAuth: false,
  });

export const checkPhoneNumber = (phoneNumber) =>
  fetch({
    method: 'GET',
    url: '/change_phone/check_grab_phone',
    params: {
      phone_number: phoneNumber,
    },
  });

export const changePhoneNumber = (payload) =>
  fetch({
    method: 'POST',
    url: '/change_phone/change_phone_number',
    body: payload,
  });

export const otpRequestForChangePhone = (payload) =>
  fetch({
    method: 'POST',
    url: '/change_phone/otp_request',
    body: payload,
  });

export const otpConfirmForChangePhone = (payload) =>
  fetch({
    method: 'POST',
    url: '/change_phone/otp_confirmation',
    body: payload,
  });

export const callOtpRequest = (payload) =>
  fetch({
    method: 'POST',
    url: '/otp_misscall_request',
    body: payload,
  });
